import React from "react";
import { OptionsType } from "react-select";
import AsyncSelect from "react-select/async";
import { XGSSelectProps, XGSSelectOption } from "./xgsSelect";
import "./xgsSelect.scss";

const maxCountOfOptionsOnSearch = 100;
const XGSAsyncSelect: React.FC<XGSSelectProps> = ({ async, ...props }) => {
  const options = props.options as OptionsType<XGSSelectOption>;

  const loadOptions = (
    inputValue: string /*, callback: (arr: XGSSelectOption[]) => void*/
  ) => {
    return Promise.resolve(filterOptions(inputValue));
  };

  const filterOptions = (inputValue: string) => {
    if (options) {
      const filteredOptions = [];
      const optionsCount = options.length;
      const lowerCaseInputValue = inputValue.toLowerCase();
      for (let i = 0; i < optionsCount; i++) {
        const currentOption = options[i];
        const valueForSearch = currentOption.valueForSearch || currentOption.value;
        if (valueForSearch.toLowerCase().includes(lowerCaseInputValue)) {
          filteredOptions.push(currentOption);
        }
        if (!props.maxOptions && filteredOptions.length > maxCountOfOptionsOnSearch) break;
      }
      return filteredOptions;
    }
    return [];
  };

  return (
    <>
      {!async && (
        <AsyncSelect
          {...props}
          cacheOptions={props.cacheOptions !== undefined ? props.cacheOptions : true}
          defaultOptions={options?.filter(
            (option: XGSSelectOption, i: number) => props.maxOptions ? (i < props.maxOptions) : (i < maxCountOfOptionsOnSearch)
          )}
          loadOptions={props.loadOptions || loadOptions}
        />
      )}
    </>
  );
};

export default XGSAsyncSelect;
